
import React from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Button, Grid } from "@mui/material";
import ImageEditor from "../../libs/imgcrop/ImageEditor";
import ImageResizer from "../extra/ImageResizer";


export default function Form({ title, companies = [], defaultValues = {},
    onSubmit = (data) => { }, onChange = (column, data) => { }, back = () => { } }) {
    const [open, setOpen] = React.useState(false)
    const { handleSubmit, control, setValue, watch } = useForm({ defaultValues: defaultValues, mode: "all" })
    const booleanFields = [
        { name: "verified", label: "Verified", watch: watch("verified") },
        { name: "active", label: "Active", watch: watch("active") },
    ];
    return (
        <>
            <Box sx={{ p: 3 }}>
                <form
                    onSubmit={handleSubmit((data) => {
                        console.log("data submit", data)
                        onSubmit(data)
                    })}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <RFG name="company" label="Company" control={control} rules={{ required: true }} className="mb-2">
                                <select >
                                    <option value="">Select Company</option>
                                    {companies.map((company) => <option value={company.id}>{company.company_name} {company.id}</option>)}
                                </select>
                            </RFG>
                            <RFG name="project_name" label="Project Name" control={control} rules={{ required: true, maxLength: 100 }} className="mb-2">
                                <input autoComplete="false" />
                            </RFG>
                            <RFG name="description" label="Description" control={control} rules={{ required: true, maxLength: 500 }} className="mb-2">
                                <input autoComplete="false" />
                            </RFG>

                            <RFG name="country" label="Country" control={control} rules={{ required: true, maxLength: 30 }} className="mb-2">
                                <input autoComplete="false" />
                            </RFG>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <RFG name="location" label="Location" control={control} rules={{ required: true, maxLength: 12 }} className="mb-2">
                                <input autoComplete="false" />
                            </RFG>
                            <Box sx={{ my: 1 }} display="flex" flexWrap="wrap" gap={2}>
                                {booleanFields.map(({ name, label, watch }) => (
                                    <RFG name={name} label={label} control={control} className="mb-2">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => setValue(name, e.target.checked)}
                                            checked={watch}
                                        />
                                    </RFG>
                                ))}
                            </Box>
                            <Box mt={2}>
                                {/* <ImageEditor onChange={(bs64) => setValue("image", bs64)} /> */}
                                <ImageResizer defaultValue={defaultValues.image} onChange={(bs64) => setValue("image", bs64)} />
                            </Box>
                            <Box textAlign="right" sx={{ my: 4 }}>
                                <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                                    Back
                                </Button>
                                <Button sx={{ mx: 2 }} className="btn-primary" type="submit">Proceed</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </>
    )
}